import React from 'react';
import { motion } from 'framer-motion';
import { Check, Shield, Lock, CreditCard } from 'lucide-react';
const includes = ['📘 Unidades completas (Introducción, señalización, EPP, prevención, primeros auxilios)', '🛠 Actividades y simulacros (Casos reales, inspecciones)', '📋 Checklists y rúbricas de evaluación', '🏫 Planificación anual semana por semana', '📂 Libro digital PDF editable y listo para imprimir', '🎁 3 Bonos profesionales (Señalización, EPP y Emergencias)'];
export function PricingSection() {
  return <section className="py-20 bg-blue-600 relative overflow-hidden" data-id="element-118">
      {/* Decorative background */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10" data-id="element-119"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-120">
        <div className="max-w-5xl mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden flex flex-col lg:flex-row" data-id="element-121">
          {/* Left Side: Content List */}
          <div className="lg:w-3/5 p-8 lg:p-12 bg-gray-50" data-id="element-122">
            <h3 className="text-2xl font-bold text-gray-800 mb-6 uppercase tracking-wide" data-id="element-123">
              ¿QUÉ HAY EN ESTE MEGA PACK?
            </h3>

            <ul className="space-y-4" data-id="element-124">
              {includes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-125">
                  <div className="bg-green-100 p-1 rounded-full mt-0.5" data-id="element-126">
                    <Check className="w-4 h-4 text-green-600" data-id="element-127" />
                  </div>
                  <span className="text-gray-700 font-medium" data-id="element-128">{item}</span>
                </li>)}
            </ul>

            <div className="mt-8 pt-8 border-t border-gray-200" data-id="element-129">
              <div className="flex items-center gap-2 text-gray-500 text-sm" data-id="element-130">
                <Shield className="w-4 h-4" data-id="element-131" />
                <span data-id="element-132">Garantía de satisfacción de 7 días</span>
              </div>
            </div>
          </div>

          {/* Right Side: Pricing Card */}
          <div className="lg:w-2/5 p-8 lg:p-12 bg-white flex flex-col justify-center items-center text-center border-l border-gray-100 relative" data-id="element-133">
            <div className="absolute top-0 right-0 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-134">
              ¡Solo por HOY!
            </div>

            <p className="text-gray-500 font-medium line-through mb-2" data-id="element-135">
              Precio Regular: $49
            </p>

            <div className="flex items-center justify-center gap-2 mb-4" data-id="element-136">
              <div className="flex items-baseline gap-2" data-id="element-137">
                <span className="text-6xl font-black text-blue-900 tracking-tight" data-id="element-138">
                  $12.99
                </span>
                <span className="text-2xl font-bold text-blue-900" data-id="element-139">USD</span>
              </div>
              <span className="bg-red-100 text-red-600 font-bold px-2 py-1 rounded text-sm transform -rotate-6" data-id="element-140">
                70% OFF
              </span>
            </div>

            <motion.a id="checkout-button" href="https://checkout1.edulabs.online/cart/42430491164770:1" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="w-full bg-yellow-400 text-blue-900 font-bold py-4 rounded-xl shadow-lg hover:bg-yellow-300 transition-colors text-lg mb-4 uppercase inline-block text-center" data-id="element-141">
              SÍ, QUIERO ACCEDER AHORA
            </motion.a>

            <div className="flex flex-col gap-2 text-xs text-gray-400" data-id="element-142">
              <div className="flex items-center justify-center gap-1" data-id="element-143">
                <CreditCard className="w-3 h-3" data-id="element-144" />
                <span data-id="element-145">Pago 100% seguro</span>
              </div>
              <div className="flex items-center justify-center gap-1" data-id="element-146">
                <Lock className="w-3 h-3" data-id="element-147" />
                <span data-id="element-148">Acceso inmediato y de por vida</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}